import { array, object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class Introduction extends PageBlock {
  public getType(): string {
    return "Introduction";
  }

  protected init(): any {
    return {
      props: {
        title: "",
        description: "",
        image: null,
        category: null,
        tags: [],
      },
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          category: string().nullable().label("카테고리"),
          title: string().required("제목을 입력해 주세요.").max(100, "100자 이하로 입력해 주세요.").label("제목"),
          description: string().required("설명을 입력해 주세요.").max(200, "200자 이하로 입력해 주세요.").label("설명"),
          image: object()
            .shape({
              uuid: string().uuid().required().label("uuid"),
              url: string().required().label("url"),
              file_name: string().required().label("file_name"),
              path: string().required().label("path"),
            })
            .required()
            .label("이미지"),
          tags: array().of(string().label("태그")).max(10, "태그는 최대 10개까지 입력 가능합니다.").label("태그 목록"),
        })
        .required()
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
